import React, {useMemo} from 'react';
import {HardwareOption} from 'shared/types/HardwareOption';
import styled from 'styled-components';
import {SVGImage} from 'components/customer/JobDashboard/columns/SVGImage';
import {OverlayTrigger} from 'shared/components/OverlayTrigger';
import {isMobile} from 'react-device-detect';
import {Icon} from 'shared/helpers';

interface HardwareOptionProps {
    options: HardwareOption[];
    value: number;
    type: 'assembly' | 'hardware' | 'legs';
    loading: boolean;
}

export const HardwareOptionImage = ({
    options,
    value,
    type,
    loading,
}: HardwareOptionProps) => {
    const [top, left, scale] = useMemo(() => {
        switch (type) {
            case 'assembly':
                if (value) {
                    return [-2, -2, 110];
                } else {
                    return [-11, 2];
                }
            case 'hardware':
                if (value) {
                    return [0, 0, 95];
                } else {
                    return [-3, -3, 115];
                }
            case 'legs':
                return [-18, -3];
            default:
                return [0, 0];
        }
    }, [type, value]);

    return (
        <>
            {options.map((item) => {
                if (item.value == value) {
                    return (
                        <OverlayTrigger
                            placement="left-end"
                            key={item.name}
                            overlay={
                                <Tooltip data-cy="hardware-option-tooltip">
                                    <strong>{item.name}</strong>
                                    <br />
                                    {item.description}
                                </Tooltip>
                            }>
                            {item.customImage ? (
                                <ImageContainerStatic>
                                    <Icon iconName={item.image} />
                                </ImageContainerStatic>
                            ) : (
                                <ImageContainer>
                                    <SVGImage
                                        src={`/${item.image}`}
                                        alt={item.name}
                                        top={top}
                                        left={left}
                                        scale={scale}
                                        loadingStatus={loading}
                                    />
                                </ImageContainer>
                            )}
                        </OverlayTrigger>
                    );
                }
            })}
        </>
    );
};

const Tooltip = styled.div`
    text-align: left;
`;

const ImageContainerStatic = styled.div`
    width: ${isMobile ? '27px' : '30px'};
    height: ${isMobile ? '27px' : '30px'};
    cursor: pointer;
`;

const ImageContainer = styled.div`
    background: ${({theme}) => theme.colors.primaryIconColor.main};
    overflow: hidden;
    position: relative;

    border-radius: 30px;
    width: ${isMobile ? '27px' : '30px'};
    height: ${isMobile ? '27px' : '30px'};
    max-height: ${isMobile ? '27px' : '30px'};

    flex-grow: 1;
    border: 2px solid ${({theme}) => theme.colors.primaryIconColor.main};
    cursor: pointer;
`;
